import React from 'react';
import Survey from './survey/Survey';
import SurveyConfirmation from './confirmation/SurveyConfirmation';
import { useRequestMeMutation } from 'src/modules/shared/slices/auth/entity/api/auth';

const SurveyController = () => {
  const [, { data: meResponse }] = useRequestMeMutation({
    fixedCacheKey: '/me',
  });

  if (!meResponse?.survey) return null;

  return (
    <>
      <Survey />
      {meResponse?.survey.externalSurvey && <SurveyConfirmation />}
    </>
  );
};

export default SurveyController;
